import { render, staticRenderFns } from "./error.vue?vue&type=template&id=6fa8b4b7"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockMessage: require('/var/www/html/fantini/frontend-2/components/block/message/index.vue').default,BlocksWrapper: require('/var/www/html/fantini/frontend-2/components/blocks-wrapper/index.vue').default})
